export default __webpack_public_path__ + "static/飞书20210924-194535-en-f43a897bd64bc216a5e3ba7e11f7faf1.jpg";